import React, { useState, useEffect } from "react";
import {
  Box,
  TableCell,
  styled,
  Divider,
  Stack,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { isEmpty, isArray } from "lodash";
import { useProposalContext } from "../..";
import { Setting } from "../../../../utils/Setting";
import { getApiData } from "../../../../utils/APIHelper";
import { toast } from "react-toastify";
import styles from "./styles";
import BudgetModal from "../../../../components/BudgetModal";
import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";
import ConfirmModel from "../../../../components/ConfirmModel";
import BudgetItemModal from "./components/BudgetItemModal";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
  padding: "1vh 0 !important",
}));

const AddStyledButton = styled(Button)(({ theme }) => ({
  background: "#0000000A",
  color: "#4D6BF6",
  boxShadow: "none",
  border: "none",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

export default function Budgets() {
  const { proposalDetails, setProposalDetails } = useProposalContext();
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedDeleteBudget, setSelectedDeleteBudget] = useState(null);
  const [selectedBudget, setSelectedBudget] = useState(null);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (proposalDetails && proposalDetails?.proposal_id) {
      getDetailsApiCall(proposalDetails?.proposal_id);
    }
  }, [proposalDetails?.proposal_id]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.getProject}?proposal_id=${id}`,
        "GET",
        {}
      );

      if (
        response.success &&
        isArray(response?.data) &&
        !isEmpty(response?.data)
      ) {
        const data = response?.data[0];
        console.log("selectedBudget value", selectedBudget);

        if (selectedBudget !== null) {
          const newMilestoneData = data?.milestone?.find(
            (m) => m.id === Number(selectedBudget?.milestone_id)
          );

          console.log("dd", data, newMilestoneData);

          if (newMilestoneData) {
            console.log("newMilestoneData", newMilestoneData.budget);

            // Find the matching budget by id
            const matchedBudget = newMilestoneData.budget.find(
              (b) => b.id === selectedBudget.id
            );

            if (matchedBudget) {
              setSelectedBudget(matchedBudget);
            }
          }
        }

        setProposalDetails(data);
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handlePrevious = () => {
    navigate(`/new-create-proposal/${proposalDetails?.proposal_id}/milestone`);
  };

  const handleNext = () => {
    const milestones = proposalDetails?.milestone || [];
    const anyMilestoneHasBudget = milestones.some(
      (milestone) =>
        Array.isArray(milestone.budget) && milestone.budget.length > 0
    );
    if (!anyMilestoneHasBudget) {
      toast.error("At least one milestone must have a budget item to proceed");
      return;
    }
    navigate(
      `/new-create-proposal/${proposalDetails?.proposal_id}/payment-group`
    );
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  const handleModalClose = () => {
    navigate("/proposals");
  };

  async function handleConfirm() {
    setButtonLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.newBudgetItem}/${parseInt(
          selectedDeleteBudget?.id
        )}`,
        "DELETE",
        {},
        { "Content-Type": "application/json" },
        true
      );
      toast.success("Budget Item Deleted Successfully");
      setSelectedDeleteBudget(null);
      getDetailsApiCall(proposalDetails?.proposal_id);
      setButtonLoader(false);
    } catch (error) {
      console.log("err===>", error);
    }
  }

  const handleClick = (item) => {
    console.log("item", item);
    setSelectedBudget(item);
  };

  return (
    <div style={{ ...styles.container, ...styles.columnFlex, gap: "15px" }}>
      <h3 style={styles.heading}>Budgets</h3>
      {loader ? (
        <center>
          <CircularProgress />
        </center>
      ) : (
        <div style={{ ...styles.columnFlex }}>
          {proposalDetails?.milestone?.map((milestone, milestoneIdx) => (
            <React.Fragment key={`milestone-${milestoneIdx}`}>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Divider
                  sx={{ flexGrow: 1, borderBottom: ".5px solid #949DAA" }}
                />
                <div
                  style={{
                    ...styles.small_text,
                    margin: "0 10px",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                  }}
                >
                  {milestone?.milestone_name}
                </div>
                <Divider
                  sx={{ flexGrow: 1, borderBottom: ".5px solid #949DAA" }}
                />
              </div>

              {milestone?.budget?.map((item, budgetIdx) => (
                <div key={`budget-${budgetIdx}`} style={styles.budgetRow}>
                  <div
                    style={{ ...styles.rowFlex, flex: 1.5, cursor: "pointer" }}
                    onClick={() => handleClick(item)}
                  >
                    <Box display="flex" alignItems="center">
                      <Box
                        component="img"
                        src={
                          !isEmpty(item?.buget_image)
                            ? item?.buget_image[0]?.image
                            : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                        }
                        alt="Project Icon"
                        sx={{
                          width: 35,
                          height: 35,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                      <span style={styles.small_sub_heading}>{item?.name}</span>
                    </Box>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Material Type</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.material_type || "-"}
                    </div>
                  </div>
                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Material Unit</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.material_unit || "-"}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Units</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.qty !== null ? item?.qty || "-" : "-"}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Manpower Rate</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {item.manpower_rate ? item?.manpower_rate : "-"}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Days</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.days || "-"}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Unit Cost</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {renderCurrencyIcon('small')}
                      {item?.material_unit_price || item.manpower_rate
                        ? formattedAmountWithoutAed(
                            item?.material_unit_price || item.manpower_rate
                          )
                        : "-"}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Total Cost</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {renderCurrencyIcon('small')}
                      {formattedAmountWithoutAed(item?.total_item)}
                    </div>
                  </div>

                  <div style={{ ...styles.rowFlex, flex: 0.3 }}>
                    <div style={{ ...styles.rowFlex }}>
                      <MdOutlineEdit
                        onClick={() => setSelectedMilestone(item)}
                        style={{
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          color: "#0D0D0E",
                        }}
                      />
                      <MdOutlineDelete
                        style={{
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          color: "#e54746",
                        }}
                        onClick={() => setSelectedDeleteBudget(item)}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <StyledTableCell>
                <AddStyledButton
                  onClick={() =>
                    setSelectedMilestone({ milestone_id: milestone.id })
                  }
                >
                  + Add Budget Item
                </AddStyledButton>
              </StyledTableCell>
            </React.Fragment>
          ))}
        </div>
      )}

      {selectedMilestone && (
        <BudgetModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedBudget={selectedMilestone}
          isEdit={selectedMilestone?.id !== undefined}
          milestones={proposalDetails?.milestone}
          proposalId={proposalDetails?.proposal_id}
          milestoneId={selectedMilestone?.milestone_id}
          getProjectDetails={getDetailsApiCall}
          setOuterButtonLoader={setButtonLoader}
        />
      )}

      {selectedDeleteBudget && (
        <ConfirmModel
          visible={!!selectedDeleteBudget}
          handleClose={() => setSelectedDeleteBudget(null)}
          confirmation={handleConfirm}
          message={`Are you sure you want to delete ${selectedDeleteBudget?.name}?`}
        />
      )}

      {selectedBudget && (
        <BudgetItemModal
          selectedBudget={selectedBudget}
          setSelectedBudget={setSelectedBudget}
          getDetailsApiCall={getDetailsApiCall}
        />
      )}
      <Divider sx={{ width: "100%" }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GreyStyledButton onClick={handlePrevious}>
          {buttonLoader ? (
            <CircularProgress size={26} style={{ color: "#fff" }} />
          ) : (
            "Previous Step"
          )}
        </GreyStyledButton>

        <Stack
          alignItems="end"
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
        >
          <GreyStyledButton onClick={handleModalClose}>Cancel</GreyStyledButton>
          <StyledButton variant="contained" onClick={handleNext}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Save & Continue"
            )}
          </StyledButton>{" "}
        </Stack>
      </Stack>
    </div>
  );
}
